// Retouches rapides proposées sur un fragment sélectionné. Partagées : ce sont
// les mêmes intentions quel que soit l'endroit d'où l'on retouche un CV.

export const QUICK_INSTRUCTIONS: Array<{ id: string; label: string; instruction: string }> = [
  { id: 'shorter', label: 'Raccourcir', instruction: 'Raccourcis ce texte tout en gardant le sens essentiel.' },
  { id: 'punchy', label: 'Plus percutant', instruction: "Rends ce texte plus percutant : verbes d'action forts, formulation directe." },
  { id: 'executive', label: 'Ton exécutif', instruction: "Reformule sur un ton exécutif / senior : impact business, vocabulaire stratégique." },
  { id: 'metrics', label: 'Mettre les chiffres en avant', instruction: 'Réordonne pour mettre les chiffres et résultats en premier. Ne change pas la véracité.' },
]
